const Input = ({
	type = 'text',
	value,
	onChange,
	placeholder,
	label,
	name,
	id,
	required = false,
	className = '',
	error = null,
	maxLength,
	autoFocus = false,
}) => {
	return (
		<div className='mb-4'>
			{label && (
				<label htmlFor={id || name} className='label'>
					{label} {required && <span className='text-danger-500'>*</span>}
				</label>
			)}
			<input
				type={type}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				name={name}
				id={id || name}
				required={required}
				className={`input w-full ${error ? 'border-danger-500 focus:ring-danger-500' : ''} ${className}`}
				maxLength={maxLength}
				autoFocus={autoFocus}
			/>
			{error && <p className='mt-1 text-sm text-danger-500'>{error}</p>}
		</div>
	);
};

export default Input;
